import { combineReducers } from "redux";
import Auth from "./Auth";
import Theme from "./Theme";
import User from "./User";
import Gui from "./Gui";
import Menu from "./Menu";
import Permissoes from "./Permissoes";
import Configuracoes from "./Configuracoes";

const reducers = combineReducers({
	theme: Theme,
	auth: Auth,
	user: User,
	gui: Gui,
	menu: Menu,
	permissoes: Permissoes,
	configuracoes: Configuracoes,
});

export default reducers;
